import { createSlice } from '@reduxjs/toolkit'

export const MbReduxCategories = createSlice({
    name: "categories",
    initialState: {
        value: []
    },
    reducers: { 
        redux_set_categories: (state, action) => {
            state.value = action.payload;
        }
    }
});

export const {redux_set_categories} = MbReduxCategories.actions;

export default MbReduxCategories.reducer;